
// import React, { useEffect } from "react";
import React, { useEffect, useState } from "react";

import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { getAuth, setPersistence, browserLocalPersistence, signOut } from "firebase/auth";

import Vehicles from "./admin/ListeVoitures";
import Login from "./auth/Login";
import RequireAuth from "./auth/RequireAuth";
import MarquesModeles from "./admin/MarquesModeles";
import LocationManager from "./admin/LocationManager";
import AdminReservations from "./admin/AdminReservations";
import ItemsManager from "./admin/ItemsManager";
import ReceptionColis from "./admin/ReceptionColis"; // Ajuste le chemin selon ton projet
import ListeColis from "./admin/ListeColis";
import BubbleImageEditor from "./admin/BubbleImageEditor.jsx"; // fichier du canvas, déplace-le dans src/pages/
import { BubblePostsList } from "./admin/BubblePostsList.jsx"; // liste
import Home from "./pages/HomeOutils";
import Contact from "./pages/Contact";
import ListeMarques from "./pages/ListeMarques";
import ListeModelesParMarque from "./pages/ListeModelesParMarque";
import OutilDetail from "./pages/OutilDetail";
import CatalogueOutils from "./pages/CatalogueOutils"; // ← 🆕 Nouvelle page catalogue
import AboutPage from "./pages/Apropos";
import ColisCardsPublic from "./pages/ColisCardsPublic";
import ScrollResetter from "./components/ScrollResetter";
import "./App.css";
import MarqueDetails from "./pages/MarqueDetails";
// Dans App.js ou le fichier principal
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/effect-coverflow";
import LoginRegister from "./pages/LoginRegister";
import Favoris from "./pages/Favoris";
import Profil from "./pages/Profil";
import OutilsHeroSliderAdmin from "./admin/OutilsHeroSliderAdmin.jsx";
import AdminMiseAJourMarqueId from "./pages/AdminMiseAJourMarqueId";
import SearchLocationForm from "./pages/SearchLocationForm";
import useVisitorTracker from "./hooks/useVisitorTracker"; // si extrait dans un fichier
import ColisageSuivi from "./pages/ColisageSuivi";
import Reservation from "./pages/Reservation";
import ReservationDetails from "./pages/ReservationDetails";
//import Navette from "./pages/Navette"; // adapte le chemin selon ton arborescence
import ColisManager from "./pages/ColisManager";
import ColisCards from "./pages/ColisCards";
import ColisEdit from "./pages/ColisEdit";
import DeveloperPortfolio from "./pages/DeveloperPortfolio";

// 🔽 Place ceci au-dessus de `export default function App() { ... }`
function ColisHub() {
  const [view, setView] = useState("cards"); // "cards" | "manager"
  const nav = useNavigate();
  const auth = getAuth();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      nav("/login"); // redirection vers la page de login
    } catch (e) {
      alert("Impossible de se déconnecter pour le moment.");
      console.error(e);
    }
  };

  return (
    <div>
      <nav className="navbar navbar-dark bg-dark">
        <div className="container d-flex gap-2 align-items-center">
          <span className="navbar-brand">Colis</span>

          <button
            className={`btn btn-sm ${view === 'cards' ? 'btn-light' : 'btn-outline-light'}`}
            onClick={() => setView('cards')}
          >
            Vue cartes
          </button>
          <button
            className={`btn btn-sm ${view === 'manager' ? 'btn-light' : 'btn-outline-light'}`}
            onClick={() => setView('manager')}
          >
            Manager
          </button>

          {/* pousse le bouton à droite */}
          <div className="ms-auto d-flex align-items-center gap-2">
            {/* (optionnel) afficher le nom de l'utilisateur si dispo */}
            {/* <span className="text-white-50 small">{auth.currentUser?.displayName}</span> */}
            <button className="btn btn-sm btn-outline-light" onClick={() => {
  if (window.confirm("Voulez-vous vous déconnecter ?")) handleLogout();
}}
>
              Se déconnecter
            </button>
          </div>
        </div>
      </nav>

      {view === 'cards' ? <ColisCards /> : <ColisManager />}
    </div>
  );
}


export default function App() {
  useEffect(() => {
    const auth = getAuth();
    setPersistence(auth, browserLocalPersistence)
      .then(() => {
        //console.log("✅ Persistance Firebase activée (localStorage)");
      })
      .catch((error) => {
        //console.error("Erreur de persistance Firebase :", error);
      });
  }, []);
  const location = useLocation();
  useVisitorTracker(location.pathname); // ✅ Appel correct
  return (
    <>
      <ScrollResetter /> {/* ← nettoyage global à chaque navigation */}

      <Routes>
        {/* Pages publiques */}
        <Route path="/" element={<Home />} />
        <Route path="/marques" element={<ListeMarques />} />
        <Route path="/outil/:slug" element={<OutilDetail />} />
        <Route path="/a-propos" element={<AboutPage />} />
        <Route path="/catalogue" element={<CatalogueOutils />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/colisage" element={<ColisageSuivi />} />
        <Route path="/reservation" element={<Reservation />} />
        <Route path="/reservation/details/:id" element={<ReservationDetails />} />
        <Route path="/nos-colis" element={<ColisCardsPublic />} />

        {/* <Route path="/navette" element={<Navette />} /> */}
        <Route path="/login" element={<Login />} />
        <Route path="/Identity/Account/Login" element={<LoginRegister mode="login" />} />
        <Route path="/Registration" element={<LoginRegister mode="register" />} />
        <Route path="/profil" element={<Profil />} />
        <Route path="/Vehiclelisting/:slug" element={<MarqueDetails />} />
        <Route path="/marques/:marqueId/modeles" element={<ListeModelesParMarque />} />
        <Route path="/admin/mise-a-jour-marqueid" element={<AdminMiseAJourMarqueId />} />
        {/* <Route path="/locations" element={<Location />} /> */}
        <Route path="/SearchLocationForm" element={<SearchLocationForm />} />

        {/* Routes d'administration */}
        <Route
          path="/admin/items"
          element={
            <RequireAuth>
              <ItemsManager />
            </RequireAuth>
          }
        />

        <Route
          path="/admin/vehicles"
          element={
            <RequireAuth>
              <Vehicles />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/LocationManager"
          element={
            <RequireAuth>
              <LocationManager />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/reservations"
          element={
            <RequireAuth>
              <AdminReservations />
            </RequireAuth>
          }
        />

        <Route
          path="/admin/marques"
          element={
            <RequireAuth>
              <MarquesModeles />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/ReceptionColis"
          element={
            <RequireAuth>
              <ReceptionColis />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/ListeColis"
          element={
            <RequireAuth>
              <ListeColis />
            </RequireAuth>
          }
        />

        <Route
          path="/admin/outils-hero-slider"
          element={<RequireAuth><OutilsHeroSliderAdmin /></RequireAuth>}
        />
        
        <Route
          path="/bubble-editor"
          element={
            <RequireAuth>
              <BubbleImageEditor />
            </RequireAuth>
          }
        />
        <Route
          path="/bubble-posts"
          element={
            <RequireAuth>
              <BubblePostsList />
            </RequireAuth>
          }
        />

        <Route
          path="/favoris"
          element={
            <RequireAuth>
              <Favoris />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/colis"
          element={
            <RequireAuth>
              <ColisHub />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/colis/:id"
          element={
            <RequireAuth>
              <ColisEdit />
            </RequireAuth>
          }
        />
        <Route path="/developer-portfolio" element={<DeveloperPortfolio />} />

      </Routes>
    </>
  );

}


